export function getCoverImg(type, rid, mid) {
  // console.log("======================");
  // console.log(type);
  let domain = import.meta.env.VITE_DOMAIN;
  if (type === "resource") {
    return `https://uro3q7uyssmv4vsmpldosqudwi0putsg.lambda-url.ap-southeast-1.on.aws/?rid=${rid}&mid=msu_cover`;
    console.log("img = ", `${domain}ores/getcover/${rid}/msu_cover`);
    return `${domain}ores/getcover/${rid}/msu_cover`;
  } else if (type === "book_detail") {
    return `https://uro3q7uyssmv4vsmpldosqudwi0putsg.lambda-url.ap-southeast-1.on.aws/?rid=${rid}&mid=msu_cover`;
    console.log("img = ", `${domain}ores/getcover/${rid}/msu_cover`);
    return `${domain}ores/getcover/${rid}/msu_cover`;
  } else if (type === "video_detail") {
    if (mid !== undefined) {
      return `https://uro3q7uyssmv4vsmpldosqudwi0putsg.lambda-url.ap-southeast-1.on.aws/?rid=${rid}&mid=${mid}`;
    }
    return `https://uro3q7uyssmv4vsmpldosqudwi0putsg.lambda-url.ap-southeast-1.on.aws/?rid=${rid}&mid=msu_cover`;
    console.log("img = ", `${domain}ores/getcover/${rid}/${mid}`);
    return `${domain}ores/getcover/${rid}/${mid}`;
  }
}
